// Header.tsx - Simple and clean
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import "./Header.css";

export default function Header() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="header">
      <div className="brand">
        <button
          onClick={() => navigate('/')}
          className="header-button"
        >
          AVANT-ELITIST
        </button>
      </div>
      <div className="shop">
        <button
          onClick={() => navigate('/products')}
          className="header-button"
        >
          SHOP
        </button>
      </div>
      <button onClick={logout} className="logout-btn">
        Logout
      </button>
    </header>
  );
}